import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from '@/components/ui/dialog'
import {RegistrationLinkPanel} from '@/components/registration-link-card'

/** `canEdit` viene de `!useGodModeReadOnly()`: regenerar el enlace es una mutación. */
export function InviteEmployeesDialog({
  businessId,
  canEdit,
  open,
  onOpenChange,
}: {
  businessId: string
  canEdit: boolean
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const {t} = useTranslation()
  const navigate = useNavigate()
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="invite-employees-dialog">
        <DialogHeader>
          <DialogTitle>{t('business.registrationLink.title')}</DialogTitle>
          <DialogDescription>{t('business.registrationLink.body')}</DialogDescription>
        </DialogHeader>
        <RegistrationLinkPanel
          businessId={businessId}
          canEdit={canEdit}
          onEditProfile={() => {
            onOpenChange(false)
            navigate(`/businesses/${businessId}/profile`)
          }}
        />
      </DialogContent>
    </Dialog>
  )
}
